import { getPromoSearchTypes } from './getPromoSearchTypes';
import { IApplicationState } from '../../types/redux';

export function getPromoSearchTypesEnabled(state: IApplicationState) {
  const promoSearchTypes = getPromoSearchTypes(state);

  return state.config.isPromoSearchTypesEnabled && Boolean(promoSearchTypes);
}
